import { registerPlugin } from '@capacitor/core';

export interface ExecuteResult {
  rows: Record<string, any>[];
  rowsAffected: number;
  insertId: number;
}

export interface BatchResult {
  results: { rowsAffected: number; insertId: number }[];
}

export interface MultiResult {
  results: ExecuteResult[];
}

export interface CsSQLitePlugin {
  open(options: { name: string }): Promise<void>;
  execute(options: { name: string; sql: string; params?: any[] }): Promise<ExecuteResult>;
  executeBatch(options: {
    name: string;
    statements: { sql: string; params?: any[] }[];
  }): Promise<BatchResult>;
  /** Execute multiple statements in a single transaction, returning full rows from each. */
  executeMulti(options: {
    name: string;
    statements: { sql: string; params?: any[] }[];
  }): Promise<MultiResult>;
  close(options: { name: string }): Promise<void>;
  deleteDatabase(options: { name: string }): Promise<void>;
}

export const CsSQLite = registerPlugin<CsSQLitePlugin>('CsSQLitePlugin');
